import ECommerceTracker from './e-commerce-tracker'

export default ECommerceTracker

export { default as GoogleAnalyticsTracker } from './trackers/google-analytics'
export { default as FirebaseAnalyticsTracker } from './trackers/firebase-analytics'
export { default as AppsflyerAnalyticsTracker } from './trackers/appsflyer-analytics'
export { default as InsiderAnalyticsTracker } from './trackers/insider-analytics'
export { default as FacebookAnalyticsTracker } from './trackers/facebook-analytics'